<template>
  <b-row class="SystemMaintenance mb-2">
    <b-col cols="12" lg="10" offset-lg="1">
      <b-card>
        <b-card-title title-tag="h2" class="mb-5 text-center">
          SYSTEM MAINTENANCE
        </b-card-title>

        <b-row style="min-height: 500px;">
          <b-col class="mb-3" cols="12" lg="2">
            <b-nav vertical class="w-100">
              <template v-for="(item, idx) in settingsNav">
                <b-nav-item
                  v-if="item.label"
                  :key="`nav_${idx}`"
                  :active="item.active"
                  :to="item.link"
                  :disabled="item.disabled"
                >
                  {{ item.label || $startCase(item.name) }}
                </b-nav-item>
                <b-nav-item
                  v-else-if="item.html"
                  :key="`nav_${idx}`"
                  :active="item.active"
                  :to="item.link"
                  :disabled="item.disabled"
                  v-html="item.html"
                />
              </template>
            </b-nav>
          </b-col>

          <b-col cols="12" lg="10" class="vld-parent">
            <router-view></router-view>
          </b-col>
        </b-row>

      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'SystemMaintenance',
  computed: {
    activeTab() {
      const routeName = this.$route.name;
      return routeName;
    },
    settingsNav() {
      const setIfActive = (item) => {
        const linkName = this.$get(item, 'link.name', '');
        return Object.assign({}, item, { active: this.activeTab === linkName });
      };
      const navArray = [
        {
          label: 'Dashboard',
          name: 'system',
          link: { name: 'maintenance.index' },
        },
        {
          label: 'Menus',
          name: 'menus',
          link: { name: 'maintenance.menus' },
          disabled: true,
        },
        {
          label: 'User Menus',
          name: 'user_menus',
          link: { name: 'maintenance.user_menus' },
          disabled: true,
        },
      ];
      return navArray.map(setIfActive)
        .map(item => Object.assign({}, item, { disabled: item.disabled || this.$ie(item.link) }));
    },
    ...mapGetters(['isLoadingRequest', 'isAdmin']),
  },
  methods: {
    ...mapActions(['startLoadingRequest', 'stopLoadingRequest']),
  },
};
</script>
<style lang="scss" scoped>
@import '../../styles/base/_variables';
.SystemMaintenance {
  .nav-link {
    margin-bottom: 5px;
    border-radius: 0.25rem;

    &:hover {
      background-color: lighten($primary, 50);
    }

    &.active {
      background-color: $primary;
      color: #fff;
    }
  }
}
</style>
